module.exports = __webpack_public_path__ + "static/img/hw_cloud.7d3e5b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hw_cloud.png
// module id = 8rP3
// module chunks = 34